module.exports = __webpack_public_path__ + "static/media/photo-1.449f7d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-extension/photo-1.jpg
// module id = 167
// module chunks = 0